var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSosafeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2C10.1892 2 12.2973 2.70103 14 3.85567V4.18557C14 8.47423 11.5676 12.2268 8 14C4.43243 12.2268 2 8.47423 2 4.18557V3.85567C3.7027 2.70103 5.77027 2 8 2ZM5.81074 7.4433C5.81074 8.68041 6.78371 9.6701 7.99993 9.6701C9.1756 9.6701 10.1486 8.63917 10.1486 7.4433C10.1486 6.24742 9.21614 5.21649 7.99993 5.21649C6.78371 5.21649 5.81074 6.20618 5.81074 7.4433Z",
    fill: "#F54286"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSosafeIcon);
export default __webpack_public_path__ + "static/media/sosafe-icon.a6eab4dd7804c208cadf5206d014b812.svg";
export { ForwardRef as ReactComponent };